import { render, staticRenderFns } from "./ZeRenMianChu.vue?vue&type=template&id=fc6726ec&scoped=true&"
var script = {}
import style0 from "./ZeRenMianChu.vue?vue&type=style&index=0&id=fc6726ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6726ec",
  null
  
)

export default component.exports